import Button from '@/components/atoms/Button'
import Icon from '@/components/atoms/Icon'
import Modal from '@/components/atoms/Modal'
import { cohortsRepository } from '@/repositories'
import profileService from '@/services/profileService'
import { modalCreators } from '@/store/ducks/modal'
import { useAppDispatch, useAppSelector } from '@/store/hooks'
import { Dialog } from '@headlessui/react'
import { useEffect } from 'react'
import dayjs from 'dayjs'
import 'dayjs/locale/pt-br'
import utc from 'dayjs/plugin/utc.js'

dayjs.extend(utc)
dayjs.locale('pt-br')

interface GoogleCalendarProps {
	disabledOnClose?: boolean
}

export function GoogleCalendar({ disabledOnClose }: GoogleCalendarProps) {
	const {
		modal: { modalInfo },
	} = useAppSelector((state) => state)

	const dispatch = useAppDispatch()

	const {
		execute: editProfile,
		isLoading,
		isSuccess,
	} = profileService.editMutation()

	const handleCloseModal = async () => {
		await editProfile({ show_modal_calendar: false })

		modalInfo()
	}

	const handleSuccessModal = async () => {
		await dispatch(cohortsRepository.util.invalidateTags(['ProgressCheck']))
		dispatch(modalCreators.closeModal())
	}

	useEffect(() => {
		if (isSuccess) handleSuccessModal()

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isSuccess])

	return (
		<Modal
			name='googleCalendarModal'
			disabledOnClose={disabledOnClose}
			onClose={handleCloseModal}
			className='relative overflow-hidden py-0 md:py-0 px-0 max-w-[531px] border-[3px] rounded-2xl border-brand-primary'
		>
			<div className='absolute top-0 right-0'>
				<img
					src={`/imgs/admin/modals/whatsapp-top-right.png`}
					width='243px'
					height='auto'
					alt='Imagem de spray no modal whatsapp'
				/>
			</div>

			<div className='flex flex-col h-full max-h-[_calc(100vh_-_80px)]'>
				<div id='drawer-content' className='flex-grow overflow-y-auto'>
					<div className='flex flex-col gap-5 pt-10 px-6 md:px-10'>
						<Icon name='google-calendar-modal' width='88' height='88' />
						<div className='flex flex-col gap-8'>
							<div className='flex flex-col gap-4'>
								<Dialog.Title
									as='h3'
									className='text-start text-3xl font-bold leading-[110%] tracking-tight text-zinc-50'
								>
									Permissões necessárias para conectar seu calendário
								</Dialog.Title>
								<p className='text-start w-full max-w-[417px] font-medium text-base text-zinc-50 leading-[140%]'>
									Certifique-se de marcar todas as opções de permissões para que
									possamos sincronizar em tempo real alterações nos convites das
									aulas.
								</p>
							</div>
							<div className='flex flex-col gap-6 mb-10'>
								{[1, 2, 3].map((_, key) => {
									return (
										<div className='flex gap-4 items-center' key={key}>
											<Icon name='check-calendar' width='24' height='24' />
											<div
												role='status'
												className='flex flex-col w-full max-w-[215px] gap-2'
											>
												<div className='h-2 bg-gray-700/70 rounded-full w-full'></div>
												<div className='h-2 bg-gray-700/70 rounded-full w-full max-w-[150px]'></div>
												<span className='sr-only'>Loading...</span>
											</div>
										</div>
									)
								})}
							</div>
						</div>
					</div>
				</div>
				<div className='flex-shrink-0 w-full flex justify-end items-center px-6 h-[80px] bg-zinc-900'>
					<Button
						type='button'
						onClick={handleCloseModal}
						className='w-full max-w-[272px] rounded-full h-[40px]'
						isLoading={isLoading}
					>
						Continuar com a conexão
					</Button>
				</div>
			</div>
		</Modal>
	)
}
